import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_HIGH_AMOUNT_CONFIRMATION_MODAL = createFcmDetails('high_amount_confirmation_modal', {
	owner: 'United PD',
	context: 'Corgi Promote Page',
	description: `Shows/Hides the high amount confirmation modal
		popup on:
			- the Corgi Promote page
			- the Promote Async page`,
	import: false,
});
